export enum ClassificationOptionSourceTypeEnum {
    Custom = 1,
    Countries = 2
}